import React from "react";
import productImage from "./WhatsApp Image 2025-12-22 at 11.27.57 PM (1) (1).png";

import "./App.css";

const Production = () => {
  return (
    <>
        <head>
        <title>OM AGRO FOODS | Premium Kesar Mango Pulp Manufacturer & Supplier</title>

        <meta
          name="description"
          content="OM AGRO FOODS offers premium quality Kesar Mango Pulp made from handpicked mangoes. Ideal for aamras, ice creams, desserts, beverages, and bulk supply."
        />

        <meta
          name="keywords"
          content="About production of om agro foods,production of natural mango pulp, how to making mango pulp, production of mango pulp, natural production of mango pulp, production of natural mango pulp, Kesar Mango Pulp, Mango Pulp Manufacturer, Mango Pulp Supplier, OM AGRO FOODS, om agro foods , natural mango pulp, mango pulp, Aamras Pulp, Bulk Mango Pulp"
        />

        <link rel="canonical" href="https://omagrofoods.vercel.app/" />

        <link rel="icon" type="image/png" href="%PUBLIC_URL%/site-logo-omagrofood.png" sizes="48x48" />
        <link rel="icon" type="image/png" href="%PUBLIC_URL%/site-logo-omagrofood.png" sizes="96x96" />
        <link rel="icon" type="image/png" href="%PUBLIC_URL%/site-logo-omagrofood.png" sizes="192x192" />
        <link rel="shortcut icon" type="image/png" href="%PUBLIC_URL%/site-logo-omagrofood.png" />
        <link rel="apple-touch-icon" type="image/png" href="%PUBLIC_URL%/site-logo-omagrofood.png" />
        <meta property="og:title" content="OM AGRO FOODS | Premium Kesar Mango Pulp" />
        <meta
          property="og:description"
          content="Premium quality Kesar Mango Pulp with rich taste, aroma, and natural sweetness. Available for retail and bulk orders."
        />
        <meta property="og:image" content={productImage} />
        <meta property="og:url" content="https://omagrofoods.vercel.app/" />
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="OM AGRO FOODS | Premium Mango Pulp" />
        <meta
          name="twitter:description"
          content="Premium Kesar Mango Pulp supplier for homes, hotels, and food industries."
        />
        <meta name="twitter:image" content={productImage} />
      </head>
    <div className="production-container">
      <h1 className="production-title">Our Production Process</h1>
      <p className="production-subtitle">
        We follow a structured and high-quality production workflow to deliver
        reliable and scalable solutions.
      </p>

      <div className="production-grid">
        <div className="production-card">
          <img 
            src="/MangoProcessingEquipmentManufacture.jpg" 
            alt="Planning" 
          />
          <h3>Planning</h3>
          <p>
            Detailed planning and requirement analysis to ensure a clear and
            efficient production roadmap.
          </p>
        </div>

        <div className="production-card">
          <img
            src="/productionimage1.jpg"
            alt="Design"
          />
          <h3>Design</h3>
          <p>
            Creative and user-friendly design focused on performance,
            accessibility, and modern UI standards.
          </p>
        </div>

        <div className="production-card">
          <img
            src="/developer-working-online-software-development-600nw-2536667025.jpg"
            alt="Development"
          />
          <h3>Development</h3>
          <p>
            Clean, scalable, and optimized code using modern technologies and
            best development practices.
          </p>
        </div>

        <div className="production-card">
          <img
            src="/H62269a024fec4ad489839f111ddfa880A.jpg"
            alt="Testing"
          />
          <h3>Testing</h3>
          <p>
            Rigorous testing to ensure quality, security, and smooth performance
            across all devices.
          </p>
        </div>

        <div className="production-card">
          <img
            src="/Juice-Plant.jpg"
            alt="Deployment"
          />
          <h3>Deployment</h3>
          <p>
            Seamless deployment with monitoring and optimization for long-term
            reliability.
          </p>
        </div>

        <div className="production-card">
          <img
            src="/download.jpg"
            alt="Maintenance"
          />
          <h3>Maintenance</h3>
          <p>
            Continuous updates, support, and improvements to keep everything
            running smoothly.
          </p>
        </div>
      </div>
    </div>
    </>
  );
};

export default Production;
